import { generateStarRating } from "./generate-star-rating";
import { reviewResponseBody } from "./review-response";
import { timeSince } from "./time-ago";
export function generateReviewList(data:any){
    return `<div class="customer-review hydrated" id="customer-review" data-review-id="">
                <div class="container review-wrapper">
                    <div class="reviewer-image">
                    ${data.reviewPhotoUrl ? `<img class="review-pic" src="${data.reviewPhotoUrl}" alt="reviewer">` : '<img class="review-pic" src="/us/en-us/_assets/images/customer-reviews/noun_profile.svg" alt="reviewer">'}
                    </div>
                    <div class="five-star-badge-display hydrated">
                        <div class="five-star-display hydrated">
                           ${generateStarRating(data,'rating')}
                        </div>
                    </div>
                    <div class="reviewer mobile-left-align">
                        <h4 class="reviewer-name">${data.reviewAuthorName ? data.reviewAuthorName : ''}</h4>
                        ${data.reviewSourceType != "" ? `<h5 class="respone-type">Via ${data.reviewSourceType ? data.reviewSourceType : ''}</h5>` : ` ` }
                    </div>
                    <div class="mobile-left-align hydrated time-ago-display">
                        <time datetime="${data.reviewTime}" title="2021-04-15T22:30:00.000Z">${timeSince(data.reviewTime)} ago</time>
                    </div>
                    <q class="review-content mobile-left-align">
                            ${data.reviewBody ?  data.reviewBody : ''}
                    </q>
                    ${(!data.reviewResponseBody  && data.reviewResponseBody != null ) ? reviewResponseBody(data) :''}
                </div>
            </div>`
}